import {
    PUBLIC_CONTACT_LOADING,
    PUBLIC_CONTACT_LOADING_DONE,
    PUBLIC_CONTACT_INIT,
    PUBLIC_CONTACT_GET,
} from '../../actions';

const INITIAL_STATE = {
    loading: false,
    contact: null,
};

const publicContact = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case PUBLIC_CONTACT_GET:
            return {
                ...state,
                contact: payload,
            };
        case PUBLIC_CONTACT_INIT:
            return { ...INITIAL_STATE };

        case PUBLIC_CONTACT_LOADING:
            return {
                ...state,
                loading: true,
            };

        case PUBLIC_CONTACT_LOADING_DONE:
            return {
                ...state,
                loading: false,
            };

        default:
            return state;
    }
};
export default publicContact;
